import React from 'react'
import PropTypes from 'prop-types'
import Table from 'antd/lib/table'

import { LoaderComponent } from '..'

import 'antd/lib/table/style/css'
import './TableComponent.scss'

const TableComponent = (props) => {
  const { loading } = props
  if (loading) {
    return (
      <div className="table-component loader-center">
        <LoaderComponent size="large" />
      </div>
    )
  }

  const pagination = () => {
    if (!props.pagination) {
      return false
    }

    return {
      current: props.pagination.page,
      defaultPageSize: props.pagination.size,
      total: props.pagination.total,
      onChange: props.onPageChange,
    }
  }

  const { columns, data } = props

  return (
    <div className="table-component antd-component">
      <Table
        {...props}
        columns={columns}
        dataSource={data}
        pagination={pagination()}
        size="small"
      />
    </div>
  )
}

TableComponent.propTypes = {
  loading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onPageChange: PropTypes.func,
}

TableComponent.defaultProps = {
  loading: true,
}

export default TableComponent
